import type { FC } from 'react';
import { useCallback } from 'react';

import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';
import { Button } from 'platform/atoms';
import { useAuthContext } from 'platform/components/AuthContext';
import { GenericErrorPage } from 'shared/routes/errors/GenericErrorPage';

/** Page to show when user is trying to access their offer with the wrong account. */
export const WrongAccountPage: FC = () => {
  const { logout } = useAuthContext();
  const handleSignOutClick = useCallback(() => void logout(), [logout]);

  return (
    <GenericErrorPage
      reason="wrong-account"
      causedBy="user-error"
      headerContent="This offer may be linked to a different email address"
    >
      <Text as="p" className="text-body-md text-center">
        <Button
          variant="secondary"
          analyticsName="account-redirect"
          aria-label="Sign out"
          onClick={handleSignOutClick}
          className={cn(
            'inline-flex h-auto w-max shrink-0 rounded-none border-0 bg-transparent p-0',
            '[&:is(:hover,:active,:disabled)]:!bg-transparent',
            'text-label-md !text-od-content-accent-brand hover:!text-od-content-hover-accent-brand disabled:!text-od-content-inactive-accent-brand',
          )}
        >
          Sign out
        </Button>{' '}
        and try another email address to view it.
      </Text>
    </GenericErrorPage>
  );
};
